import { ARVI, waLink, DEFAULT_WA_MESSAGE } from "../../lib/arvi";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-maroon text-ivory/80 py-16 md:py-20 border-t border-[hsl(var(--gold)/0.3)]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <p className="font-display text-4xl tracking-[0.25em] text-ivory">
              {ARVI.brand}
            </p>
            <p className="mt-6 max-w-sm italic font-display text-lg text-ivory/70">
              {ARVI.tagline}
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="text-overline text-gold mb-4">Explore</p>
            <ul className="space-y-3 text-[14px]">
              <li><a href="#legacy" data-testid="footer-link-legacy" className="hover:text-gold transition-colors">The Legacy</a></li>
              <li><a href="#collections" data-testid="footer-link-collections" className="hover:text-gold transition-colors">Collections</a></li>
              <li><a href="#gallery" data-testid="footer-link-gallery" className="hover:text-gold transition-colors">Gallery</a></li>
              <li><a href="#pricing" data-testid="footer-link-pricing" className="hover:text-gold transition-colors">Investment</a></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="text-overline text-gold mb-4">Connect</p>
            <ul className="space-y-3 text-[14px]">
              <li>
                <a
                  href={waLink(DEFAULT_WA_MESSAGE)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="hover:text-gold transition-colors"
                >
                  WhatsApp · {ARVI.whatsappDisplay}
                </a>
              </li>
              <li>
                <a
                  href={ARVI.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram-link"
                  className="hover:text-gold transition-colors"
                >
                  Instagram · {ARVI.instagramHandle}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-ivory/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[12px] text-ivory/50">
          <p>© {new Date().getFullYear()} ARVI. A Mother's Art. A Son's Promise.</p>
          <p className="italic">Hand-painted in India · One canvas at a time</p>
        </div>
      </div>
    </footer>
  );
}
